var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useMemo, useState } from "react";
import { logClientRuntimeError } from "../../../../services/clientErrorLog";
import { displaySnackbarErrMsg, getAllTimeDateRangeForSTOrderDetails } from "../../../../services/apiServices/salesRepDataService";
import { clampStOrderDetailsDateRangeToToday, getDefaultDateRange, isStOrderDetailsSelectableDate, todayAtMidnight, } from "./dateRangeFormatUtils";
export { formatDateForAPI, getDefaultDateRange, isStOrderDetailsSelectableDate } from "./dateRangeFormatUtils";
/** First day of calendar month containing `date`. */
function startOfMonth(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return new Date(d.getFullYear(), d.getMonth(), 1);
}
/**
 * Anchor the dual calendar on the selection: left = month before anchor, right = anchor month.
 * Defaults to today-based view when dates are missing.
 */
export function getViewStartMonthForRange(value) {
    var _a;
    try {
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var end = (value === null || value === void 0 ? void 0 : value.endDate) ? new Date(value.endDate) : null;
        var start = (value === null || value === void 0 ? void 0 : value.startDate) ? new Date(value.startDate) : null;
        var anchor = (_a = end !== null && end !== void 0 ? end : start) !== null && _a !== void 0 ? _a : today;
        anchor.setHours(0, 0, 0, 0);
        var anchorMonthStart = startOfMonth(anchor);
        return new Date(anchorMonthStart.getFullYear(), anchorMonthStart.getMonth() - 1, 1);
    }
    catch (error) {
        logClientRuntimeError("getViewStartMonthForRange", error);
        var fallback = new Date();
        fallback.setHours(0, 0, 0, 0);
        return new Date(fallback.getFullYear(), fallback.getMonth() - 1, 1);
    }
}
export var ST_REPORTS_PRESET_ALL_TIME = "stReports_preset_allTime";
export var ST_REPORTS_PRESET_RESET = "Reset";
function normalizeDate(date) {
    try {
        var normalized = new Date(date);
        normalized.setHours(0, 0, 0, 0);
        return normalized.getTime();
    }
    catch (error) {
        logClientRuntimeError("normalizeDate", error);
        return Number.NaN;
    }
}
/** Rolling 365 days ending today (`dateFrom` = today − 365 days, `dateTo` = today). */
export function getLast365DaysRange() {
    var endDate = todayAtMidnight();
    var startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - 365);
    return { startDate: startDate, endDate: endDate };
}
/**
 * Last 12 completed calendar months, excluding the current partial month.
 * Example (today 05/18/2026): `dateFrom` = 05/01/2025, `dateTo` = 04/30/2026.
 */
export function getLast12CompletedMonthsRange() {
    var today = todayAtMidnight();
    var currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    var endDate = new Date(currentMonthStart.getFullYear(), currentMonthStart.getMonth(), 0);
    var startDate = new Date(currentMonthStart.getFullYear(), currentMonthStart.getMonth() - 12, 1);
    return { startDate: startDate, endDate: endDate };
}
export function buildPresets() {
    try {
        var today_1 = todayAtMidnight();
        var yesterday_1 = new Date(today_1);
        yesterday_1.setDate(today_1.getDate() - 1);
        var daysAgo_1 = function (days) {
            var date = new Date(today_1);
            date.setDate(today_1.getDate() - days);
            return date;
        };
        var startOfMonthPreset_1 = function (offset) {
            if (offset === void 0) { offset = 0; }
            return new Date(today_1.getFullYear(), today_1.getMonth() - offset, 1);
        };
        var endOfMonthPreset_1 = function (offset) {
            if (offset === void 0) { offset = 0; }
            return new Date(today_1.getFullYear(), today_1.getMonth() - offset + 1, 0);
        };
        var startOfYear_1 = function (offset) {
            if (offset === void 0) { offset = 0; }
            return new Date(today_1.getFullYear() - offset, 0, 1);
        };
        var endOfYear_1 = function (offset) {
            if (offset === void 0) { offset = 0; }
            return new Date(today_1.getFullYear() - offset, 11, 31);
        };
        return [
            { labelKey: "stReports_preset_today", getDates: function () { return ({ startDate: today_1, endDate: today_1 }); } },
            { labelKey: "stReports_preset_yesterday", getDates: function () { return ({ startDate: yesterday_1, endDate: yesterday_1 }); } },
            { labelKey: "stReports_preset_last7Days", getDates: function () { return ({ startDate: daysAgo_1(6), endDate: today_1 }); } },
            { labelKey: "stReports_preset_last30Days", getDates: function () { return ({ startDate: daysAgo_1(29), endDate: today_1 }); } },
            { labelKey: "stReports_preset_last90Days", getDates: function () { return ({ startDate: daysAgo_1(89), endDate: today_1 }); } },
            { labelKey: "stReports_preset_last365Days", getDates: function () { return getLast365DaysRange(); } },
            { labelKey: "stReports_preset_last12Months", getDates: function () { return getLast12CompletedMonthsRange(); } },
            { labelKey: "stReports_preset_lastMonth", getDates: function () { return ({ startDate: startOfMonthPreset_1(1), endDate: endOfMonthPreset_1(1) }); } },
            { labelKey: "stReports_preset_lastYear", getDates: function () { return ({ startDate: startOfYear_1(1), endDate: endOfYear_1(1) }); } },
            { labelKey: ST_REPORTS_PRESET_ALL_TIME, kind: "allTime" },
            { labelKey: ST_REPORTS_PRESET_RESET, kind: "reset" },
        ];
    }
    catch (error) {
        logClientRuntimeError("buildPresets", error);
        var today_2 = todayAtMidnight();
        return [{ labelKey: "stReports_preset_today", getDates: function () { return ({ startDate: new Date(today_2), endDate: new Date(today_2) }); } }];
    }
}
/** UI display format for Sales Order Details date range (`MM/dd/yyyy`, all languages). API uses `formatDateForAPI` (`yyyy-MM-dd`). */
export function formatDateForDisplay(date) {
    try {
        if (!date) {
            return "";
        }
        var month = String(date.getMonth() + 1).padStart(2, "0");
        var day = String(date.getDate()).padStart(2, "0");
        var year = date.getFullYear();
        return "".concat(month, "/").concat(day, "/").concat(year);
    }
    catch (error) {
        logClientRuntimeError("formatDateForDisplay", error);
        return "";
    }
}
export function getPresetLabelForRange(range, presets) {
    var _a;
    try {
        if (!(range === null || range === void 0 ? void 0 : range.startDate) || !(range === null || range === void 0 ? void 0 : range.endDate)) {
            return "";
        }
        if (range.label) {
            return range.label;
        }
        var selectedStart_1 = normalizeDate(range.startDate);
        var selectedEnd_1 = normalizeDate(range.endDate);
        var matchedPreset = presets.find(function (preset) {
            if (!preset.getDates) {
                return false;
            }
            var presetRange = preset.getDates();
            return normalizeDate(presetRange.startDate) === selectedStart_1 && normalizeDate(presetRange.endDate) === selectedEnd_1;
        });
        return (_a = matchedPreset === null || matchedPreset === void 0 ? void 0 : matchedPreset.labelKey) !== null && _a !== void 0 ? _a : "";
    }
    catch (error) {
        logClientRuntimeError("getPresetLabelForRange", error);
        return "";
    }
}
export function DateRangePickerBL(onApply, onCancel, onReset) {
    var _this = this;
    var today = useMemo(function () { return todayAtMidnight(); }, []);
    var presets = useMemo(function () {
        try {
            return buildPresets();
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.presets", error);
            var t_1 = todayAtMidnight();
            return [{ labelKey: "stReports_preset_today", getDates: function () { return ({ startDate: new Date(t_1), endDate: new Date(t_1) }); } }];
        }
    }, []);
    var _a = useState(function () {
        try {
            return new Date(today.getFullYear(), today.getMonth() - 1, 1);
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.viewStartMonth.init", error);
            return new Date(today);
        }
    }), viewStartMonth = _a[0], setViewStartMonth = _a[1];
    var leftMonth = viewStartMonth;
    var rightMonth = useMemo(function () {
        try {
            return new Date(viewStartMonth.getFullYear(), viewStartMonth.getMonth() + 1, 1);
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.rightMonth", error);
            return new Date(viewStartMonth);
        }
    }, [viewStartMonth]);
    var _b = useState("start"), selecting = _b[0], setSelecting = _b[1];
    var _c = useState(null), hoverDate = _c[0], setHoverDate = _c[1];
    var _d = useState(false), allTimeLoading = _d[0], setAllTimeLoading = _d[1];
    var _e = useState(function () {
        try {
            return getDefaultDateRange();
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.draft.init", error);
            var t = todayAtMidnight();
            return { startDate: t, endDate: t, label: undefined };
        }
    }), draft = _e[0], setDraft = _e[1];
    /** Updates draft only — server call happens on Apply (except Reset). */
    var selectPresetDraft = function (preset) {
        try {
            if (preset.kind === "reset") {
                onReset === null || onReset === void 0 ? void 0 : onReset();
                return;
            }
            if (preset.kind === "allTime") {
                return;
            }
            if (!preset.getDates) {
                return;
            }
            var _a = preset.getDates(), startDate = _a.startDate, endDate = _a.endDate;
            var range = { startDate: startDate, endDate: endDate, label: preset.labelKey };
            setDraft(range);
            setViewStartMonth(getViewStartMonthForRange(range));
            setSelecting("start");
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.selectPresetDraft", error);
        }
    };
    var selectAllTimeDraft = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, startDate, endDate, range, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setAllTimeLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getAllTimeDateRangeForSTOrderDetails()];
                case 2:
                    _a = _b.sent(), startDate = _a.startDate, endDate = _a.endDate;
                    range = clampStOrderDetailsDateRangeToToday({
                        startDate: startDate,
                        endDate: endDate,
                        label: ST_REPORTS_PRESET_ALL_TIME,
                    });
                    setDraft(range);
                    setViewStartMonth(getViewStartMonthForRange(range));
                    setSelecting("start");
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    logClientRuntimeError("DateRangePickerBL.selectAllTimeDraft", error_1);
                    displaySnackbarErrMsg();
                    return [3 /*break*/, 5];
                case 4:
                    setAllTimeLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handlePresetClick = function (preset) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(preset.kind === "allTime")) return [3 /*break*/, 2];
                    return [4 /*yield*/, selectAllTimeDraft()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    selectPresetDraft(preset);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDayClick = function (date) {
        try {
            if (!isStOrderDetailsSelectableDate(date)) {
                return;
            }
            if (selecting === "start" || (draft.startDate && date < draft.startDate)) {
                setDraft({ startDate: date, endDate: null, label: undefined });
                setSelecting("end");
            }
            else {
                setDraft(function (prev) { return (__assign(__assign({}, prev), { endDate: date, label: undefined })); });
                setSelecting("start");
            }
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.handleDayClick", error);
        }
    };
    var handleApply = function () {
        var _a;
        try {
            if (draft.startDate && draft.endDate) {
                var label = (_a = draft.label) !== null && _a !== void 0 ? _a : getPresetLabelForRange(draft, presets);
                var clamped = clampStOrderDetailsDateRangeToToday({
                    startDate: draft.startDate,
                    endDate: draft.endDate,
                    label: label || undefined,
                });
                if (clamped.startDate && clamped.endDate) {
                    onApply({
                        startDate: clamped.startDate,
                        endDate: clamped.endDate,
                        label: clamped.label || undefined,
                    });
                }
            }
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.handleApply", error);
        }
    };
    var syncDraftFromValue = useCallback(function (value) {
        var _a, _b;
        try {
            var clamped = clampStOrderDetailsDateRangeToToday({
                startDate: (_a = value === null || value === void 0 ? void 0 : value.startDate) !== null && _a !== void 0 ? _a : null,
                endDate: (_b = value === null || value === void 0 ? void 0 : value.endDate) !== null && _b !== void 0 ? _b : null,
                label: value === null || value === void 0 ? void 0 : value.label,
            });
            setDraft({
                startDate: clamped.startDate,
                endDate: clamped.endDate,
                label: clamped.label,
            });
            setViewStartMonth(getViewStartMonthForRange(value));
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.syncDraftFromValue", error);
        }
    }, []);
    var prevMonth = function () {
        try {
            setViewStartMonth(function (prev) { return new Date(prev.getFullYear(), prev.getMonth() - 1, 1); });
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.prevMonth", error);
        }
    };
    var nextMonth = function () {
        try {
            setViewStartMonth(function (prev) { return new Date(prev.getFullYear(), prev.getMonth() + 1, 1); });
        }
        catch (error) {
            logClientRuntimeError("DateRangePickerBL.nextMonth", error);
        }
    };
    return {
        presets: presets,
        leftMonth: leftMonth,
        rightMonth: rightMonth,
        draft: draft,
        hoverDate: hoverDate,
        allTimeLoading: allTimeLoading,
        setHoverDate: setHoverDate,
        handlePresetClick: handlePresetClick,
        handleDayClick: handleDayClick,
        handleApply: handleApply,
        syncDraftFromValue: syncDraftFromValue,
        onCancel: onCancel,
        prevMonth: prevMonth,
        nextMonth: nextMonth,
    };
}
